import * as React from "react";
import { useEffect, useState } from "react";
import { Cookies } from 'react-cookie';
import { FaCubes, FaHandHoldingDroplet, FaPrint, FaTruckPickup } from 'react-icons/fa6';
import { TbBrandOffice, TbTruckReturn } from 'react-icons/tb';
import { ColorRing } from 'react-loader-spinner';
import { Link, useNavigate } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert'
import { toast, ToastContainer } from 'react-toastify';
import { Autocomplete, Pagination, TextField } from "../../../node_modules/@mui/material/index";
import { Table } from "../Common/table";
import './DashboardStyle.css';
import { ClearSession } from "../Common/Common";

const cookies = new Cookies();

const Dashboard = ({ open }) => {

    const [EventDropDown, setEventDropdown] = useState([])
    const [VenueDropDown, setVenueDropDown] = useState([])
    const [tableData, setTableData] = useState([])
    const [trackingTabledata, setTrackingtableData] = useState([])
    const [custodianRecords, setCustodianRecords] = useState([])
    const [District, setDistrict] = useState('')
    const [CustodianCode, setCustodianCode] = useState('')
    const [VenueCode, setVenueCode] = useState('')
    const [loading, setLoading] = useState(false)
    const [SubLoading, setSubLoading] = useState(false)
    const [districtRecords, setDistrictRecords] = useState(null)
    const [TotalDistrict, setTotalDistrict] = useState(null)
    const [VenueRecords, setvenueRecords] = useState([])
    const [DynamicRecords, setDynamicRecords] = useState([])
    const [dashboardRecords, setDashboardRecords] = useState([])
    const [districtDropdown, setDistrictDropdown] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const navigate = useNavigate();
    const [userCodeDropdown, setUserCodeDropdown] = useState([])
    const [CustodianDropdown, setCustedianDropdown] = useState([])
    const [showCastodianBox, setCastodianBox] = useState(false)
    const [showVanueBox, setVanueBox] = useState(false)
    const [showTotalBox, setTotalBox] = useState(false)
    const [showDistrictBox, setShowDistrictBox] = useState(true);
    const [showDynamicgrid, setShowDynamicgrid] = useState(false)
    const [Record, setRecord] = useState([]);
    const Token = cookies.get('token')
    const [filterData, setFilterData] = useState({
        SearchText: "",
        StartValue: "1",
        SearchFieldValue: "",
    })
    const [NextStatus, setIsNextStatus] = useState(false)
    const [PrevStatus, setIsPrevStatus] = useState(false)
   

    const LoginUserCode = cookies.get('loginUserCode')
    const inputRefs = React.useRef([]);
    const statusCodeType = "";

    const handleClear = () => {
        setRecord(
            {
                totalData: '',
                pickedByCourierFromPressCount: '',
                handoverToCustodianCount: '',
                pickedByVenueInchargeCount: '',
                reachedAtVenueCount: '',
                trunksOpenCount: '',
                trunksSealedCount: '',
                pickedByVenueInchargeReturnCount: '',
                handoverToHOCount: '',
                handoverToCustodianReturnCount: '',
                pickedbyCourierFromCustodianReturnCount: '',
            }
        );
        setDistrictRecords(null);
        setFormData({
            "EventCode": "",
            "UserCode": "",
            "VenueCode": "",
            "DistrictCode": "",
            "DeliveryPartner": "",
            "CustodianCode": "",
            "LoginSessionID": ""
        })
        setIsVisible(false)
    };

    const [isVisible, setIsVisible] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const [formData, setFormData] = useState({
        "EventCode": "",
        "UserCode": '',
        "VenueCode": "",
        "DistrictCode": "",
        "DeliveryPartner": "",
        "CustodianCode": "",
        "LoginSessionID": "",
        "TrunkID": ""
    });


    const getTrackingData = async (CurrentPage, i) => {
        const data = {
            ...filterData,
            ...formData,
            Token: cookies.get('token'),
            LoginUserCode: cookies.get('loginUserCode'),
            Source: 'web',
            Type: 'S',
            "TrunkID": i ? i : '',
            PageIndex: '1',
            PageSize: '20',
        }
        setLoading(true)
        await fetch('/api/ReportController/Tracking', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }
        ).then(async (response) => {
            let res = await response.json();
            if (res.status === 'SUCCESS') {
                setTrackingtableData(res)
                setIsModalOpen(true)
                setLoading(false)
            }
            else if (res.message === "EXPIRED") {
                ClearSession();

            }
            else if (res.status === "ERROR") {
                toast.error(res.message, {

                })
                setTrackingtableData(res)
                setLoading(false)
            }
        }).catch((err) => {
            toast.error(err.message, {

            })
            setLoading(false)
        }, [])
    }

    const getDashboarddata = async () => {
        let data1 = {
            ...formData, Token, LoginUserCode
        }
        await fetch(`/api/DashboardController/ShowDashboardData`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data1)
        }).then(async (response) => {
            const responseData = await response.json();
            if (responseData.status === "SUCCESS") {
                setRecord(responseData);
            }
            else if (responseData.message === "EXPIRED") {
                ClearSession();
            }
            else if (responseData.status === "ERROR") {
                toast.error(responseData.message, {

                })
            }
        }).catch((err) => {
        })
    };
    const districtDataTable = document.getElementById('districtDataTable');

    const ScrollFunction = async () => {
        // Scroll to the districtDataTable
        if (districtDataTable) {
            districtDataTable.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });

        }
    }
    const getDistrictData = async () => {
        let data1 = {
            ...formData, Token, LoginUserCode, Type: 'GetDistrict'
        }
        await fetch(`/api/DashboardController/GetDistrictWiseData`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data1)
        }).then(async (response) => {
            const responseData = await response.json();
            if (responseData.status === "SUCCESS") {
                setDistrictRecords(responseData);
                setTableData(response)
                setIsVisible(true);
                setShowDistrictBox(true)
                setShowDynamicgrid(false)
                setCastodianBox(false)
                setVanueBox(false)
                setTotalBox(false)
            }
            else if (responseData.message === "EXPIRED") {
                ClearSession();
            }
            else {
                throw new Error('Error fetching data from API');
            }
        }).catch((err) => {
        })
    };

    
    const districtrecord = async () => {
        let data1 = {
            ...formData, Token, LoginUserCode,
            Type: ' GetAllCustodian',
        }
        await fetch(`/api/DashboardController/GetCustodianWiseData`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data1)
        }).then(async (response) => {
            const responseData = await response.json();
            if (responseData.status === "SUCCESS") {
                setTotalDistrict(responseData);
                setTableData(response)
                setIsModalOpen(true)
            }
            else if (responseData.message === "EXPIRED")
            {
                ClearSession();
            }
            else {
                throw new Error('Error fetching data from API');
            }
        }).catch((err) => {
        })
    };
    const userCodeDropdownList = async () => {
        let Condition = " And UserGroupID In(3,4)";
        let TextPart = "UserName"
        let ValuePart = "UserCode"
        let TableName = "UserMaster"
        let data = { Token, LoginUserCode, Condition, TextPart, ValuePart, TableName }
        await fetch('/api/User/BindDropDownList',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                if (res.status === "SUCCESS") {
                    setUserCodeDropdown(res.dropDownList);
                }
                else if (res.message === "EXPIRED") {
                    ClearSession();

                }
                else if (res.message !== "") {

                }

            }).catch((err) =>
                toast.error(err.message, {
                    position: 'top-center'
                })
            );

    };


    const EventDropdownList = async () => {
        let data = { Token, LoginUserCode }
        await fetch('/api/MasterController/GetEvent',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setEventDropdown(res.eventList);
            }).catch((err) => console.log(err));
    };

    const VenueDropdownList = async (eventCode, district) => {
        let data = { Token, LoginUserCode, eventCode, district, Type: 'GetVenue' }
        await fetch('/api/MasterController/GetVenue',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setVenueDropDown(res.venueList);
            }).catch((err) => console.log(err));
    };

    const CustodianDropdownList = async (event, district) => {
        let data = { Token, LoginUserCode, EventCode: event, district, Type: 'GetCustodian' }
        await fetch('/api/MasterController/GetCustodian',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setCustedianDropdown(res.custodianList);

            }).catch((err) => console.log(err));
    };

    const Custodianwisedata = async (i) => {
        let data1 = {
            ...formData,
            Token,
            LoginUserCode,
            LoginSessionID: '',
            "DistrictCode": i,
            "VenueCode": "",
            "CustodianCode": "",
            Type: 'GetCustodian'
        }
        await fetch(`/api/DashboardController/GetCustodianWiseData`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data1)
        }).then(async (response) => {
            const responseData = await response.json();
            if (responseData.status === "SUCCESS") {
                setCustodianRecords(responseData)
                setTableData(response)
            }
            else if (responseData.message === "EXPIRED")
            {
                ClearSession();
            }
            else {
                throw new Error('Error fetching data from API');
            }
        }).catch((err) => {
        })

    };
    const [statusCode, setStatusCode] = useState(null);


    const DynamicGriddata = async (i, currentPage) => {
        let PageIndex = 1
        if (currentPage === '') {
            currentPage = 1
        }
        if (currentPage !== undefined && typeof (currentPage) !== "object") {
            PageIndex = currentPage;
            setCurrentPageNo(currentPage);
            //console.log(currentPage, 'CurrentPage');
        }
        else {
            setCurrentPageNo(1);
            //console.log(currentPage, 'CurrentPage');
        }
        //  console.log(i, 'treette');
        let data1 = {
            ...formData,
            Token,
            LoginUserCode,
            LoginSessionID: '',
            //"DistrictCode": '',
            //"VenueCode": "",
            //"CustodianCode": "",
            Type: i ? i : '',
            PageIndex: `${PageIndex}`

        }
        await fetch(`/api/DashboardController/DashboardDataGrid`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data1)
        }).then(async (response) => {
            const responseData = await response.json();
            if (responseData.Status === "SUCCESS") {
                // console.log(responseData, 'this is response data in dasboard')
                setDynamicRecords(responseData)
                setTableData(response)
                setIsVisible(true)
                setShowDistrictBox(false)
                setShowDynamicgrid(true)
                setCastodianBox(false)
                setVanueBox(false)
                setTotalBox(false)
            }
            else if (responseData.message === "EXPIRED")
            {
                ClearSession();
            }
            else {
                setDynamicRecords([])
                throw new Error('Error fetching data from API');
            }
            setSubLoading(true)
        }).catch((err) => {
        })

    }

    const Venuewisedata = async (i) => {
        let data1 = {
            ...formData,
            Token,
            LoginUserCode,
            LoginSessionID: '',
            "DistrictCode": District ? District : '',
            "VenueCode": '',
            "CustodianCode": i,
            Type: 'GetVenue'
        }
        await fetch(`/api/DashboardController/GetVenueWiseData`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data1)
        }).then(async (response) => {
            const responseData = await response.json();
            if (responseData.status === "SUCCESS") {
                setvenueRecords(responseData)
                setTableData(response)
            }
            else if (responseData.message === "EXPIRED")
            {
                ClearSession();
            }
            else {
                throw new Error('Error fetching data from API');
            }
        }).catch((err) => {
        })

    };


    const dasboardalldata = async (i) => {
        let data1 = {
            ...formData,
            Token,
            LoginUserCode,
            LoginSessionID: '',
            "DistrictCode": District ? District : '',
            "VenueCode": i,
            "CustodianCode": CustodianCode ? CustodianCode : '',
            "RequestType": "S"
        }
        await fetch(`/api/DashboardController/ShowDashboardDetailData`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data1)
        }).then(async (response) => {
            const responseData = await response.json();
            if (responseData.status === "SUCCESS") {
                setDashboardRecords(responseData)
                setTableData(responseData)
            } else if (responseData.message === "EXPIRED") {
                ClearSession();
            }
            else {
                throw new Error('Error fetching data from API');
            }
        }).catch((err) => {
        })

    };
    const [ColoredRow, setColoredRow] = useState('')
    const handleHighlight = (id) => {
        setColoredRow(id)

    }

    const handleCheckboxChange = (checked, trunkCode, bodyIndex) => {
        let trunkIDsArray = formData.TrunkID ? formData.TrunkID.split(",") : [];
        while (trunkIDsArray.length <= bodyIndex) {
            trunkIDsArray.push("");
        }
        if (checked) {
            trunkIDsArray[bodyIndex] = trunkCode;
        }
        else {
            trunkIDsArray[bodyIndex] = "";
        }
        const trunkIDs = trunkIDsArray.filter(Boolean).join(",");
        setFormData((prevFormData) => ({
            ...prevFormData,
            TrunkID: trunkIDs,
        }));
    };

    const UpdateTrunkStatus = (value, name) => {
        confirmAlert({
            message: 'Do you want to update this trunk status ?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => UpdateTrunk(value, name)
                },
                {
                    label: 'No',
                    onClick: () => setColoredRow(null)
                }
            ]
        });
    }
    const UpdateTrunk = async (value, name) => {
        let data1 = {
            ...formData,
            Token,
            LoginUserCode,
            LoginSessionID: '',
            TrunkStatus: statusCode,
            NextStatus: false,
            PreviousStatus: false,
        }
        if (name === "PreviousStatus") {
            data1.PreviousStatus = value;
        } else if (name === "NextStatus") {
            data1.NextStatus = value;
        }
        setLoading(true)
        await fetch(`/api/DashboardController/UpdateTrunkStatus`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data1)
        }).then(async (response) => {
            const responseData = await response.json();
            if (responseData.status === "SUCCESS") {
                toast.success(responseData.message, {
                    position: 'top-center'
                })
                getDashboarddata();
                DynamicGriddata(statusCode, '');
                setLoading(false)
                formData.TrunkID = "";

            }
            else if (responseData.status === "ERROR")
            {
                toast.error(responseData.message, {
                    position: 'top-center'
                })
                setLoading(false)
            } else if (responseData.message === "EXPIRED") {
                ClearSession();
            }
            else {
                throw new Error('Error fetching data from API');
            }
            setLoading(false)
        }).catch((err) => {
            toast.error(err.message, {
                position: 'top-center',
            })
        })

    };
    const handleChange1 = (i, value) => {
        statusCode ? DynamicGriddata(statusCode, value) : DynamicGriddata('', value)
        
    };

    const DistrictDropdownList = async (event) => {
        let data = { Token, LoginUserCode, EventCode: event, Type: 'GetDistrict' }
        await fetch('/api/MasterController/GetVenue',
            {
                Type: 'GetDistrict',
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setDistrictDropdown(res.district);

            }).catch((err) => console.log(err));

    };

    const countNo = Math.ceil((parseInt(tableData.totalRecord) / parseInt(tableData.pageSize)))

    useEffect(() => {
        document.title = 'Dashboard'
        EventDropdownList()
        userCodeDropdownList()
    }, [])


    return (
        <>
            <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
                <div className='Dashboard'>
                    <h6 className='fw-bold' style={{ color: '#194c63' }}>Dashboard</h6>
                    <div className=' ' style={{ "position": "relative" }} data-aos="fade-down" data-aos-duration="2000">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="content-box ">
                                    <div className="form-box service-content-area">
                                        <div className="row align-items-end">
                                            <div className="col-lg-4 col-md-6 col-sm-12" >
                                                <div className="fields">
                                                    <label className="form-label">Event<span className="Required">*</span></label>
                                                    <Autocomplete
                                                        value={EventDropDown?.find((item) => item?.eventCode === formData?.EventCode) || null}
                                                        onChange={(event, newValue) => {
                                                            setFormData({ ...formData, EventCode: newValue?.eventCode || '' });
                                                            DistrictDropdownList(newValue?.eventCode || '');
                                                            CustodianDropdownList(newValue?.eventCode || '', '');
                                                            VenueDropdownList(newValue?.eventCode || '', '');
                                                        }}
                                                        options={EventDropDown || []}
                                                        getOptionLabel={(option) => ` ${option.eventName}` || ''}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                style={{ backgroundColor: 'white' }}
                                                                placeholder="Event"
                                                                variant="outlined"
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter') {
                                                                        inputRefs.current['txtDistrict'].focus();
                                                                    }
                                                                }}

                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </div>


                                            <div className="col-lg-4 col-md-6 col-sm-12">
                                                <div className="fields">
                                                    <label className="form-label">User</label>
                                                    <Autocomplete
                                                        ref={ref => (inputRefs.current['txtUserCode'] = ref)}
                                                        value={userCodeDropdown?.find((item) => item?.valuePart === formData?.UserCode) || null}
                                                        onChange={(e, newValue) => {
                                                            setFormData({ ...formData, UserCode: newValue?.valuePart || '' })

                                                        }}
                                                        options={userCodeDropdown || []}
                                                        getOptionLabel={(option) => ` ${option.textPart}` || ''}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                style={{ backgroundColor: 'white' }}
                                                                placeholder="User"
                                                                variant="outlined"
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter') {
                                                                        inputRefs.current['txtDistrict'].focus();
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6 col-sm-12" >

                                                <div className="fields">
                                                    <label className="form-label">District</label>
                                                    <Autocomplete
                                                        value={districtDropdown?.find((item) => item?.districtCode === formData?.DistrictCode) || null}
                                                        onChange={(e, newValue) => {
                                                            setFormData({ ...formData, DistrictCode: newValue?.districtCode || '' })
                                                            CustodianDropdownList(formData.EventCode, newValue?.districtCode || '');
                                                            VenueDropdownList(formData.EventCode, newValue?.districtCode || '');

                                                        }}
                                                        options={districtDropdown || []}
                                                        getOptionLabel={(option) => ` ${option.districtName}` || ''}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                style={{ backgroundColor: 'white' }}
                                                                placeholder="District"
                                                                variant="outlined"
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter') {
                                                                        inputRefs.current['txtCustodian'].focus();
                                                                    }
                                                                }}

                                                            />
                                                        )}
                                                    />
                                                </div>

                                            </div>
                                            <div className="col-lg-4 col-md-6 col-sm-12" >
                                                <div className="fields">
                                                    <label className="form-label">Custodian</label>
                                                    <Autocomplete
                                                        value={CustodianDropdown?.find((item) => item?.custodianCode === formData?.CustodianCode) || null}

                                                        onChange={(e, newValue) => {
                                                            setFormData({ ...formData, CustodianCode: newValue?.custodianCode || '' })

                                                        }}
                                                        options={CustodianDropdown || []}
                                                        getOptionLabel={(option) => option.custodianName || ''}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                style={{ backgroundColor: 'white' }}
                                                                placeholder="Custodian"
                                                                variant="outlined"
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter') {
                                                                        inputRefs.current['txtDeliveryPartner'].focus();
                                                                    }
                                                                }}

                                                            />
                                                        )}
                                                    />
                                                </div>

                                            </div>

                                            <div className="col-lg-4 col-md-6 col-sm-12">

                                                <div className="fields">
                                                    <label className="form-label"> Venue</label>
                                                    <Autocomplete

                                                        value={VenueDropDown?.find((item) => item?.venueCode === formData?.VenueCode) || null}

                                                        onChange={(e, newValue) => {
                                                            setFormData({ ...formData, VenueCode: newValue?.venueCode || '' })

                                                        }}
                                                        options={VenueDropDown || []}
                                                        getOptionLabel={(option) => option.venueName || ''}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                style={{ backgroundColor: 'white' }}
                                                                placeholder="Venue"
                                                                variant="outlined"
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter') {

                                                                    }
                                                                }}

                                                            />
                                                        )}
                                                    />
                                                </div>

                                            </div>
                                            <div className="col-lg-12 mt-4">
                                                <div className="lms-new-button ">
                                                    <button className="button save-btn" onClick={() => {
                                                        (
                                                            <>
                                                                {getDashboarddata()}
                                                                {getDistrictData()}
                                                                {ScrollFunction()}
                                                            </>
                                                        )

                                                    }} >
                                                        <i className="fa fa-search" /> Search
                                                    </button>
                                                    <button className="button reset-btn" onClick={handleClear}>
                                                        <i className="bi bi-arrow-clockwise" /> Reset
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='dash_status shadow p-1 pb-4 mt-3 rounded'>
                            <ul className='list-unstyled d-flex flex-wrap gap-x-1 gap-y-1 '>
                                <li className="pointer">
                                    <div className="card card-radius  border-left" style={{ color: "#cbceef" }} >
                                        <div className="card-body" >
                                            <div className="row text-center text-dark" onClick={() => {
                                                Record.totalData ?
                                                    (
                                                        <>
                                                            {getDistrictData()}
                                                            {ScrollFunction()}
                                                        </>
                                                    )

                                                    : <></>
                                            }} >
                                                <b style={{ textAlign: '-webkit-center' }}>
                                                    <FaCubes style={{ fontSize: "45px", color: Record.totalOrderColor }} />
                                                    Total scanned Trunks for dispatch from WBCSC(Pre-Exam)</b>
                                                <div className="mb-2 ">
                                                    {Record.totalData}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li className="pointer">
                                    <div className="card card-radius  border-left" style={{ color: "#cbceef" }} >
                                        <div className="card-body" >
                                            <div className="row text-center text-dark" onClick={() => {

                                                Record.pickedByCourierFromPressCount ?
                                                    (
                                                        <>
                                                            {DynamicGriddata('S1001', '')}
                                                            {setStatusCode('S1001')}
                                                            {ScrollFunction()

                                                            }
                                                        </>
                                                    )
                                                    : <></>

                                                //setShowDynamicgrid(true)
                                                //setCastodianBox(false)
                                                //setShowDistrictBox(false)

                                                //setTotalBox(false)
                                                //setVanueBox(false)
                                            }}

                                            >
                                                <b style={{ textAlign: '-webkit-center' }}>
                                                    <FaPrint style={{ fontSize: "37px", color: 'red' }} />
                                                    Pick up by WBCSC Officials <br /> (Pre-Exam)</b>
                                                <div className="mb-2 ">
                                                    {Record.pickedByCourierFromPressCount}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li className="pointer">
                                    <div className="card card-radius  border-left" style={{ color: "#cbceef" }} >
                                        <div className="card-body" >
                                            <div className="row text-center text-dark" onClick={() => {

                                                Record.handoverToCustodianCount ?
                                                    (
                                                        <>
                                                            {DynamicGriddata('S1002', '')}
                                                            {setStatusCode('S1002')}
                                                            {ScrollFunction()}
                                                        </>
                                                    )
                                                    : <></>

                                                //setShowDynamicgrid(true)
                                                //setCastodianBox(false)
                                                //setShowDistrictBox(false)

                                                //setTotalBox(false)
                                                //setVanueBox(false)

                                            }} >
                                                <b style={{ textAlign: '-webkit-center' }}>
                                                    <FaHandHoldingDroplet style={{ fontSize: "37px", color: 'lightgreen' }} />
                                                    Handover to custodian</b>
                                                <div className="mb-2">
                                                    {Record.handoverToCustodianCount}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li className="pointer">
                                    <div className="card card-radius  border-left" style={{ color: "#cbceef" }} >
                                        <div className="card-body" >
                                            <div className="row text-center text-dark" onClick={() => {

                                                Record.pickedByVenueInchargeCount ?
                                                    (
                                                        <>
                                                            {DynamicGriddata('S1003', '')}
                                                            {setStatusCode('S1003')}
                                                            {ScrollFunction()}
                                                        </>
                                                    )
                                                    : <></>

                                                //setShowDynamicgrid(true)
                                                //setCastodianBox(false)
                                                //setShowDistrictBox(false)
                                                //setTotalBox(false)
                                                //setVanueBox(false)


                                            }} >
                                                <b style={{ textAlign: '-webkit-center' }} >
                                                    <FaTruckPickup style={{ fontSize: "37px", color: 'blue' }} />
                                                    Pick up by venue in-charge from custodian (Pre-Exam)</b>
                                                <div className="mb-2">
                                                    {Record.pickedByVenueInchargeCount}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li className="pointer">
                                    <div className="card card-radius  border-left" style={{ color: "#cbceef" }} >
                                        <div className="card-body" >
                                            <div className="row text-center text-dark" onClick={() => {

                                                Record.reachedAtVenueCount ?
                                                    (
                                                        <>
                                                            {DynamicGriddata('S1004', '')}
                                                            {setStatusCode('S1004')}
                                                            {ScrollFunction()}
                                                        </>
                                                    )
                                                    : <></>

                                                //setShowDynamicgrid(true)
                                                //setCastodianBox(false)
                                                //setShowDistrictBox(false)
                                                //setTotalBox(false)
                                                //setVanueBox(false)


                                            }} >
                                                <b style={{ textAlign: '-webkit-center' }}>
                                                    <FaTruckPickup style={{ fontSize: "37px", color: 'orange' }} />
                                                    Reached Venue</b>
                                                <div className="mb-2">
                                                    {Record.reachedAtVenueCount}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <li className="pointer">
                                    <div className="card card-radius  border-left" style={{ color: "#cbceef" }} >
                                        <div className="card-body" >
                                            <div className="row text-center text-dark" onClick={() => {
                                                Record.pickedByVenueInchargeReturnCount ?
                                                    (
                                                        <>
                                                            {DynamicGriddata('S1007', '')}
                                                            {setStatusCode('S1007')}
                                                            {
                                                                ScrollFunction()
                                                            }
                                                        </>
                                                    )
                                                    : <></>

                                                //setShowDynamicgrid(true)
                                                //setCastodianBox(false)
                                                //setShowDistrictBox(false)

                                                //setTotalBox(false)
                                                //setVanueBox(false)


                                            }} >
                                                <b style={{ textAlign: '-webkit-center' }}
                                                >
                                                    <TbTruckReturn style={{ fontSize: "37px", color: 'grey' }} />
                                                    Return movement by venue in-charge </b>
                                                <div className="mb-2">
                                                    {Record.pickedByVenueInchargeReturnCount}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li className="pointer">
                                    <div className="card card-radius  border-left" style={{ color: "#cbceef" }} >
                                        <div className="card-body" >
                                            <div className="row text-center text-dark" onClick={() => {

                                                Record.handoverToCustodianReturnCount ?
                                                    (
                                                        <>
                                                            {DynamicGriddata('S1008', '')}
                                                            {setStatusCode('S1008')}
                                                            {ScrollFunction()}
                                                        </>)
                                                    : <></>

                                                //setShowDynamicgrid(true)
                                                //setCastodianBox(false)
                                                //setShowDistrictBox(false)

                                                //setTotalBox(false)
                                                //setVanueBox(false)


                                            }} >
                                                <b style={{ textAlign: '-webkit-center' }}>
                                                    <FaHandHoldingDroplet style={{ fontSize: "37px", color: 'magenta' }} />
                                                    Handed over to custodian <br /> (Post-Exam)
                                                </b>
                                                <div className="mb-2">
                                                    {Record.handoverToCustodianReturnCount}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li className="pointer">
                                    <div className="card card-radius  border-left" style={{ color: "#cbceef" }} >
                                        <div className="card-body" >
                                            <div className="row text-center text-dark" onClick={() => {

                                                Record.pickedbyCourierFromCustodianReturnCount ?
                                                    (
                                                        <>
                                                            {DynamicGriddata('S1009', '')}
                                                            {setStatusCode('S1009')}
                                                            {ScrollFunction()}
                                                        </>)
                                                    : <></>

                                                //setShowDynamicgrid(true)
                                                //setCastodianBox(false)
                                                //setShowDistrictBox(false)

                                                //setTotalBox(false)
                                                //setVanueBox(false)


                                            }} >
                                                <b style={{ textAlign: '-webkit-center' }}>
                                                    <FaPrint style={{ fontSize: "37px", color: 'cyan' }} />
                                                    Pick up by WBCSC Officials <br /> (Post-Exam)
                                                </b>
                                                <div className="mb-2">
                                                    {Record.pickedbyCourierFromCustodianReturnCount}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li className="pointer">
                                    <div className="card card-radius  border-left" style={{ color: "#cbceef" }} >
                                        <div className="card-body" >
                                            <div className="row text-center text-dark" onClick={() => {

                                                Record.handoverToHOCount ?
                                                    (
                                                        <>
                                                            {DynamicGriddata('S1010', '')}
                                                            {setStatusCode('S1010')}
                                                            {ScrollFunction()}
                                                        </>
                                                    )
                                                    : <></>

                                                //setShowDynamicgrid(true)
                                                //setCastodianBox(false)
                                                //setShowDistrictBox(false)

                                                //setTotalBox(false)
                                                //setVanueBox(false)


                                            }} >
                                                <b style={{ textAlign: '-webkit-center' }}>
                                                    <TbBrandOffice style={{ fontSize: "37px", color: 'purple' }} />

                                                    Handed over to WBCSC(Post-Exam)</b>
                                                <div className="mb-2">
                                                    {Record.handoverToHOCount}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </li>

                            </ul>

                        </div>

                    </div>

                    {
                        Record.totalData !== '0' &&
                        (showDistrictBox ?
                            (districtRecords !== null ?
                                (isVisible && <section className="recoard-table mt-3" id="districtDataTable">
                                    <div className="row" >
                                        <div className="col-lg-12">
                                            <div className="content-box">
                                                <div className="heading-box d-block d-sm-flex " >

                                                    <div className="heading d-flex  " style={{ padding: "0px" }}>
                                                        <b style={{ fontSize: "1rem" }}>District data</b>
                                                        <div className="totalrecord ms-5">
                                                            {districtRecords.totalDashboardData !== undefined && districtRecords.totalDashboardData !== null ?
                                                                (`Total Data : ${districtRecords.totalDashboardData}`)
                                                                :
                                                                (`No record found`)}
                                                        </div>
                                                    </div>
                                                    <u> <div className="popup mt-2 me-4 d-flex" title="History" data-toggle="modal" data-target="#exampleModalCenter" style={{ cursor: "pointer", marginLeft: "10px" }} onClick={districtrecord}>
                                                        {districtRecords.totalDistrict !== undefined && districtRecords.totalDistrict !== null ? (
                                                            districtRecords.hTotalDistrict !== undefined && districtRecords.hTotalDistrict !== null ? (
                                                                (`${districtRecords.hTotalDistrict}: ${districtRecords.totalDistrict}`)
                                                            ) : (
                                                                `No record found`
                                                            )
                                                        ) : (
                                                            `No record found`
                                                        )}
                                                    </div>
                                                    </u>

                                                </div>
                                                <div className="recoard-bata service-content-area">
                                                    <>
                                                        <div className="table-responsive">
                                                            <div className="table-responsive">
                                                                <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                                    <thead className="sticky-top">
                                                                        <tr>
                                                                            <th>{districtRecords.hDistrictName}</th>
                                                                            <th>{districtRecords.hDistrictCode}</th>
                                                                            <th>{districtRecords.hDistrictCount}</th>
                                                                        </tr>
                                                                    </thead>
                                                                    {isModalOpen && (
                                                                        <div className="modal show" tabIndex="-1" role="dialog">
                                                                            <div className="modal-dialog" role="document">
                                                                                <div className="modal-content   " style={{ backgroundColor: "#fff" }}>
                                                                                    <div className="modal-header">

                                                                                        <div className="heading-box d-block d-sm-flex">
                                                                                            <div className="heading">
                                                                                                <h6 className="m-0 mb-2 mb-sm-0 font-weight-bold text-primary">
                                                                                                    {TotalDistrict.totalDashboardData !== undefined && TotalDistrict.totalDashboardData !== null ?
                                                                                                        (`Total Record : ${TotalDistrict.totalDashboardData}`)
                                                                                                        :
                                                                                                        (`No record found`)}
                                                                                                </h6>
                                                                                            </div>

                                                                                        </div>
                                                                                        <button title="History" data-toggle="modal" data-target="#exampleModalCenter" onClick={closeModal} style={{ marginLeft: "10px" }}>
                                                                                            <i className="fa-solid fa-xmark" /></button>


                                                                                    </div>
                                                                                    <div class="modal-body">
                                                                                        <section className="recoard-table mt-3">
                                                                                            <div className="row">
                                                                                                <div className="col-lg-12">
                                                                                                    <div className="content-box">

                                                                                                        <div className="recoard-bata service-content-area" style={{ padding: "0px" }}>
                                                                                                            {!loading ?
                                                                                                                (
                                                                                                                    <>
                                                                                                                        <div className="table-responsive" style={{
                                                                                                                            oveflow: "auto",
                                                                                                                            maxHeight: "300px"
                                                                                                                        }} >
                                                                                                                            <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                                                                                                <thead className="sticky-top">

                                                                                                                                    <tr>
                                                                                                                                        <th>{TotalDistrict.hCustodianCode}</th>
                                                                                                                                        <th>{TotalDistrict.hCustodianName}</th>
                                                                                                                                        <th>{TotalDistrict.hCustodianCount
                                                                                                                                        }</th>
                                                                                                                                    </tr>


                                                                                                                                </thead>
                                                                                                                                <tbody>
                                                                                                                                    {TotalDistrict?.custodianList !== null ?
                                                                                                                                        (
                                                                                                                                            (TotalDistrict?.custodianList)?.map((event, index) => (
                                                                                                                                                <tr key={index} className="tablerow" onClick={() => handleHighlight(event)} style={{ background: event === ColoredRow ? '#cbe2ff' : '' }}>
                                                                                                                                                    <td>{event.custodianCode}</td>
                                                                                                                                                    <td>{event.custodianName}</td>
                                                                                                                                                    <td>{event.custodianCount}</td>

                                                                                                                                                </tr>
                                                                                                                                            ))
                                                                                                                                        ) : (<></>)}
                                                                                                                                </tbody>
                                                                                                                            </table>


                                                                                                                        </div>
                                                                                                                        {countNo > 1 ?
                                                                                                                            <Pagination count={countNo} variant="outlined" page={currentPageNo} shape="rounded" />

                                                                                                                            : ''}
                                                                                                                    </>
                                                                                                                ) : (
                                                                                                                    <div className='d-flex align-items-center justify-center'>

                                                                                                                    </div>
                                                                                                                )
                                                                                                            }

                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>

                                                                                        </section>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    <tbody>



                                                                        {districtRecords?.districtList !== null ?
                                                                            (
                                                                                (districtRecords?.districtList)?.map((event, index) => (
                                                                                    <tr key={index} onClick={() => {
                                                                                        handleHighlight(event)
                                                                                        Custodianwisedata(event.districtCode)
                                                                                        setDistrict(event.districtCode)
                                                                                        setCastodianBox(true);
                                                                                        setShowDistrictBox(false)
                                                                                    }

                                                                                    } style={{ cursor: 'pointer', background: event === ColoredRow ? '#cbe2ff' : '' }}>
                                                                                        <td>{event.districtName}</td>
                                                                                        <td>{event.districtCode}</td>
                                                                                        <td>{event.districtCount}</td>


                                                                                    </tr>
                                                                                ))
                                                                            ) : (<></>)}
                                                                    </tbody>
                                                                </table>

                                                            </div>
                                                        </div>
                                                    </>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>)
                                : <></>) : <></>)}

                    {
                        Record.totalData !== '0' &&
                        (showCastodianBox ?
                            (custodianRecords !== null ?

                                (isVisible && <section className="recoard-table mt-3">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="content-box">
                                                <div className="heading-box d-block d-sm-flex">

                                                    <div className="heading d-flex mt-2">


                                                        <button type="submit" className='search-btn Filter-Search-Button-main d-flex-row-reverse ' title="Search"
                                                            onClick={() => {
                                                                setShowDistrictBox(true)
                                                                setCastodianBox(false)

                                                            }}
                                                        >
                                                            <i className="fa-solid fa-arrow-left"></i>
                                                        </button>
                                                        <b style={{ fontSize: "1rem" }}> Custodian data</b>
                                                        <div className="totalrecord ms-5">
                                                            {custodianRecords.totalDashboardData !== undefined && custodianRecords.totalDashboardData !== null ?
                                                                (`Total Data : ${custodianRecords.totalDashboardData}`)
                                                                :
                                                                (`No record found`)}
                                                        </div>

                                                    </div>
                                                    <div className="popup mt-2 me-4 d-flex">
                                                        {/*<div className="totalrecord ms-2">*/}
                                                        {/*    {custodianRecords.totalCustodian !== undefined && custodianRecords.totalCustodian !== null ? (*/}
                                                        {/*        custodianRecords.hTotalCustodian !== undefined && custodianRecords.hTotalCustodian !== null ? (*/}
                                                        {/*            (`${custodianRecords.hTotalCustodian}: ${custodianRecords.totalCustodian}`)*/}
                                                        {/*        ) : (*/}
                                                        {/*            `No record found`*/}
                                                        {/*        )*/}
                                                        {/*    ) : (*/}
                                                        {/*        `No record found`*/}
                                                        {/*    )}*/}
                                                        {/*</div>*/}
                                                        {/*    <button title="History" data-toggle="modal" data-target="#exampleModalCenter" onClick={() => {*/}

                                                        {/*    getTrackingData()*/}

                                                        {/*}} style={{ marginLeft: "10px" }}> <i className="fa-solid fa-server" /></button>*/}
                                                    </div>
                                                </div>
                                                <div className="recoard-bata service-content-area">

                                                    <>
                                                        <div className="table-responsive">
                                                            <div className="table-responsive">
                                                                <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                                    <thead className="sticky-top">
                                                                        <tr>
                                                                            <th>{custodianRecords.hCustodianName}</th>
                                                                            <th>{custodianRecords.hCustodianCode}</th>
                                                                            <th>{custodianRecords.hCustodianCount}</th>

                                                                        </tr>
                                                                    </thead>
                                                                    {isModalOpen && (
                                                                        <div className="modal show" tabIndex="-1" role="dialog">
                                                                            <div className="modal-dialog" role="document">
                                                                                <div className="modal-content   " style={{ backgroundColor: "#fff" }}>
                                                                                    <div className="modal-header">

                                                                                        <div className="heading-box d-block d-sm-flex">
                                                                                            <div className="heading">
                                                                                                <h6 className="m-0 mb-2 mb-sm-0 font-weight-bold text-primary">
                                                                                                    {custodianRecords.totalCustodian !== undefined && custodianRecords.totalCustodian !== null ?
                                                                                                        (`Total Custodian  : ${custodianRecords.totalCustodian}`)
                                                                                                        :
                                                                                                        (`No record found`)}
                                                                                                </h6>
                                                                                            </div>

                                                                                        </div>
                                                                                        <button title="History" data-toggle="modal" data-target="#exampleModalCenter" onClick={closeModal} style={{ marginLeft: "10px" }}>
                                                                                            <i className="fa-solid fa-xmark" /></button>


                                                                                    </div>
                                                                                    <div class="modal-body">

                                                                                        <section className="recoard-table mt-3">
                                                                                            <div className="row">
                                                                                                <div className="col-lg-12">
                                                                                                    <div className="content-box">

                                                                                                        <div className="recoard-bata service-content-area" style={{ padding: "0px" }}>
                                                                                                            {!loading ?
                                                                                                                (
                                                                                                                    <>
                                                                                                                        <div className="table-responsive" style={{
                                                                                                                            oveflow: "auto",
                                                                                                                            maxHeight: "300px"
                                                                                                                        }} >
                                                                                                                            <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                                                                                                <thead className="sticky-top">

                                                                                                                                    <tr>
                                                                                                                                        <th>{custodianRecords.hCustodianName}</th>
                                                                                                                                        <th>{custodianRecords.hCustodianCode}</th>
                                                                                                                                        <th>{custodianRecords.hCustodianCount}</th>
                                                                                                                                    </tr>


                                                                                                                                </thead>
                                                                                                                                <tbody>
                                                                                                                                    {districtRecords?.custodianList !== null ?
                                                                                                                                        (
                                                                                                                                            (districtRecords?.custodianList)?.map((event, index) => (
                                                                                                                                                <tr key={index}>
                                                                                                                                                    <td>{event.custodianName}</td>
                                                                                                                                                    <td>{event.custodianCode}</td>
                                                                                                                                                    <td>{event.custodianCount}</td>

                                                                                                                                                </tr>
                                                                                                                                            ))
                                                                                                                                        ) : (<></>)}
                                                                                                                                </tbody>
                                                                                                                            </table>


                                                                                                                        </div>
                                                                                                                        {countNo > 1 ?
                                                                                                                            <Pagination count={countNo} variant="outlined" page={currentPageNo} shape="rounded" />

                                                                                                                            : ''}
                                                                                                                    </>
                                                                                                                ) : (
                                                                                                                    <div className='d-flex align-items-center justify-center'>

                                                                                                                    </div>
                                                                                                                )
                                                                                                            }

                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>

                                                                                        </section>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    <tbody>
                                                                        {custodianRecords?.custodianList !== null ?
                                                                            (
                                                                                (custodianRecords?.custodianList)?.map((custodian, index) => (
                                                                                    <tr key={index} onClick={() => {
                                                                                        Venuewisedata(custodian.custodianCode)
                                                                                        setCustodianCode(custodian.custodianCode)

                                                                                        setVanueBox(true)
                                                                                        setCastodianBox(false)

                                                                                    }} style={{ cursor: 'pointer' }}>
                                                                                        <td>{custodian.custodianName}</td>
                                                                                        <td>{custodian.custodianCode}</td>
                                                                                        <td>{custodian.custodianCount}</td>

                                                                                    </tr>
                                                                                ))
                                                                            ) : (<></>)}
                                                                    </tbody>
                                                                </table>

                                                            </div>
                                                        </div>
                                                    </>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>)
                                : <></>) : <></>
                        )
                    }
                    {
                        Record.totalData !== '0' &&
                            showVanueBox ?
                            (isVisible && <section className="recoard-table mt-3">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="content-box">
                                            <div className="heading-box d-block d-sm-flex">
                                                <div className="heading d-flex mt-2">
                                                    <button type="submit" className='search-btn Filter-Search-Button-main d-flex-row-reverse ' title="Search"
                                                        onClick={() => {
                                                            setCastodianBox(true)
                                                            setVanueBox(false)

                                                        }}
                                                    >
                                                        <i className="fa-solid fa-arrow-left"></i>
                                                    </button>
                                                    <b style={{ fontSize: "1rem" }}> Venue data</b>
                                                    <div className="totalrecord ms-5">
                                                        {VenueRecords.totalDashboardData !== undefined && VenueRecords.totalDashboardData !== null ?
                                                            (`Total Data : ${VenueRecords.totalDashboardData}`)
                                                            :
                                                            (`No record found`)}
                                                    </div>

                                                </div>
                                                <p className="popup mt-2 me-4">

                                                    {/*<div className="totalrecord ms-2">*/}
                                                    {/*    {VenueRecords.totalVenue !== undefined && VenueRecords.totalVenue !== null ? (*/}
                                                    {/*        VenueRecords.hTotalVenue !== undefined && VenueRecords.hTotalVenue !== null ? (*/}
                                                    {/*            (`${VenueRecords.hTotalVenue}: ${VenueRecords.totalVenue}`)*/}
                                                    {/*        ) : (*/}
                                                    {/*            `No record found`*/}
                                                    {/*        )*/}
                                                    {/*    ) : (*/}
                                                    {/*        `No record found`*/}
                                                    {/*    )}*/}
                                                    {/*</div>*/}


                                                    {/* <button title="History" data-toggle="modal" data-target="#exampleModalCenter" onClick={getTrackingData} style={{ marginLeft: "10px" }}> <i className="fa-solid fa-server" /></button>*/}
                                                </p>
                                            </div>
                                            <div className="recoard-bata service-content-area">
                                                <>
                                                    <div className="table-responsive">
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                                <thead className="sticky-top">
                                                                    <tr>
                                                                        <th>{VenueRecords.hVenueName}</th>
                                                                        <th>{VenueRecords.hVenueCode}</th>
                                                                        <th>{VenueRecords.hVenueCount}</th>

                                                                    </tr>
                                                                </thead>
                                                                {isModalOpen && (
                                                                    <div className="modal show" tabIndex="-1" role="dialog">
                                                                        <div className="modal-dialog" role="document">
                                                                            <div className="modal-content   " style={{ backgroundColor: "#fff" }}>
                                                                                <div class="modal-header">
                                                                                    <h5 class="modal-title font-weight-bold" id="exampleModalLabel">History data</h5>
                                                                                    {/*<button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={closeModal} style={{ fontWeight: "bold" }}>*/}
                                                                                    {/*    <span aria-hidden="true">&times;</span>*/}
                                                                                    {/*</button>*/}
                                                                                    <button title="History" data-toggle="modal" data-target="#exampleModalCenter" onClick={closeModal} style={{ marginLeft: "10px" }}>
                                                                                        <i className="fa-solid fa-xmark" /></button>
                                                                                </div>
                                                                                <div class="modal-body">
                                                                                    <section className="recoard-table">
                                                                                        <div className="row">
                                                                                            <div className="col-lg-12">
                                                                                                <div className="content-box">
                                                                                                    <div className="heading-box d-block d-sm-flex">
                                                                                                        <div className="heading">
                                                                                                            <h6 className="m-0 mb-2 mb-sm-0 font-weight-bold text-primary">
                                                                                                                {trackingTabledata.totalRecord !== undefined && trackingTabledata.totalRecord !== null ?
                                                                                                                    (`Total Records : ${trackingTabledata.totalRecord}`)
                                                                                                                    :
                                                                                                                    (`No record found`)}
                                                                                                            </h6>
                                                                                                        </div>

                                                                                                    </div>
                                                                                                    <div className="recoard-bata service-content-area" style={{ padding: "0px" }}>
                                                                                                        {!loading ?
                                                                                                            (
                                                                                                                <>
                                                                                                                    <div className="table-responsive " style={{
                                                                                                                        oveflow: "auto",
                                                                                                                        maxHeight: "300px"
                                                                                                                    }}>
                                                                                                                        {trackingTabledata?.length !== 0 ?
                                                                                                                            (
                                                                                                                                trackingTabledata?.totalRecord !== null ? (<table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                                                                                                    <thead className="sticky-top">
                                                                                                                                        <tr>

                                                                                                                                            <th>{trackingTabledata.hImage}</th>
                                                                                                                                            <th>{trackingTabledata.hMap}</th>
                                                                                                                                            <th>{trackingTabledata.hPacketStatus}</th>
                                                                                                                                            <th>{trackingTabledata.hEvent}</th>
                                                                                                                                            <th>{trackingTabledata.hVenue}</th>
                                                                                                                                            <th>{trackingTabledata.hCustodian}</th>
                                                                                                                                            <th>{trackingTabledata.hDistrict}</th>
                                                                                                                                            <th>{trackingTabledata.hVehicleNo}</th>
                                                                                                                                            <th>{trackingTabledata.hAssignedTo}</th>
                                                                                                                                            <th>{trackingTabledata.hLatitude}</th>
                                                                                                                                            <th>{trackingTabledata.hLongitude}</th>
                                                                                                                                            <th>{trackingTabledata.hCreatedBy}</th>
                                                                                                                                            <th>{trackingTabledata.hCreatedDate}</th>
                                                                                                                                            <th>{trackingTabledata.hModifiedBy}</th>
                                                                                                                                            <th>{trackingTabledata.hModifiedDate}</th>
                                                                                                                                        </tr>
                                                                                                                                    </thead>
                                                                                                                                    <tbody>
                                                                                                                                        {trackingTabledata?.trackingData !== null ?
                                                                                                                                            (
                                                                                                                                                (trackingTabledata?.trackingData)?.map((event, index) => (
                                                                                                                                                    <tr key={index}>


                                                                                                                                                        {/*  <td ><a type="button" href={event.image} target="_blank"> <i className="fa fa-image" style={{ color: "blue" }}></i></a> </td>*/}
                                                                                                                                                        <td>
                                                                                                                                                            {event.image ? (
                                                                                                                                                                <Link style={{ cursor: 'pointer' }} to={`/Images#data:image/png;base64,${event.image}`} target="_blank">
                                                                                                                                                                    <i className="fa fa-image" style={{ color: "blue" }}></i>
                                                                                                                                                                </Link>
                                                                                                                                                            ) : (
                                                                                                                                                                <div></div>
                                                                                                                                                            )}
                                                                                                                                                        </td>
                                                                                                                                                        <td >
                                                                                                                                                            {event.map ? (
                                                                                                                                                                <a type="button" href={event.map} target="_blank"> <i className="fas fa-map-marker-alt" style={{ color: "blue" }}></i></a>
                                                                                                                                                            ) : (
                                                                                                                                                                <a type="button" href="https://www.google.co.in/maps/@28.6469655,77.0932634,10z?hl=en&entry=ttu" target="_blank"> <i className="fas fa-map-marker-alt" style={{ color: "blue" }}></i></a>
                                                                                                                                                            )}
                                                                                                                                                        </td>
                                                                                                                                                        <td>{event.packetStatus}</td>
                                                                                                                                                        <td>{event.event}</td>
                                                                                                                                                        <td>{event.venue}</td>
                                                                                                                                                        <td>{event.custodian}</td>
                                                                                                                                                        <td>{event.district}</td>
                                                                                                                                                        <td>{event.vehicleNo}</td>
                                                                                                                                                        <td>{event.assignedTo}</td>
                                                                                                                                                        <td>{event.latitude}</td>
                                                                                                                                                        <td>{event.longitude}</td>
                                                                                                                                                        <td>{event.createdBy}</td>
                                                                                                                                                        <td>{event.createdDate}</td>
                                                                                                                                                        <td>{event.modifiedBy}</td>
                                                                                                                                                        <td>{event.modifiedDate}</td>
                                                                                                                                                    </tr>
                                                                                                                                                ))
                                                                                                                                            ) : (<></>)}
                                                                                                                                    </tbody>
                                                                                                                                </table>) : (<></>)

                                                                                                                            ) : (<></>)}
                                                                                                                    </div>
                                                                                                                    {countNo > 1 ?
                                                                                                                        <Pagination count={countNo} variant="outlined" page={currentPageNo} shape="rounded" />

                                                                                                                        : ''}
                                                                                                                </>
                                                                                                            ) : (
                                                                                                                <div className='d-flex align-items-center justify-center'>

                                                                                                                </div>
                                                                                                            )
                                                                                                        }

                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                    </section>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                <tbody>
                                                                    {VenueRecords?.venueList !== null ?
                                                                        (
                                                                            (VenueRecords?.venueList)?.map((venue, index) => (
                                                                                <tr key={index} onClick={() => {
                                                                                    dasboardalldata(venue.venueCode)

                                                                                    setVenueCode(venue.venueCode)
                                                                                    setTotalBox(true)
                                                                                    setVanueBox(false)
                                                                                }} style={{ cursor: 'pointer' }}>
                                                                                    <td>{venue.venueName}</td>
                                                                                    <td>{venue.venueCode}</td>
                                                                                    <td>{venue.venueCount}</td>

                                                                                </tr>
                                                                            ))
                                                                        ) : (<></>)}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>) : <></>}
                    {
                        Record.totalData !== '0' &&
                            showTotalBox ?
                            (isVisible && <section className="recoard-table mt-3">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="content-box">
                                            <div className="heading-box d-block d-sm-flex">
                                                <div className="heading d-flex mt-2">
                                                    <button type="submit" className='search-btn Filter-Search-Button-main d-flex-row-reverse ' title="Search"
                                                        onClick={() => {
                                                            setVanueBox(true)
                                                            setTotalBox(false)

                                                        }}
                                                    >
                                                        <i className="fa-solid fa-arrow-left"></i>
                                                    </button>
                                                    <b style={{ fontSize: "1rem" }}>  Total Data</b>
                                                    <div className="totalrecord ms-5">
                                                        {dashboardRecords.totalDashboardData !== undefined && dashboardRecords.totalDashboardData !== null ?
                                                            (`Total Data : ${dashboardRecords.totalDashboardData}`)
                                                            :
                                                            (`No record found`)}
                                                    </div>

                                                </div>
                                                {/*<p className="popup mt-2 me-4">History<button title="History" data-toggle="modal" data-target="#exampleModalCenter" onClick={getTrackingData} style={{ marginLeft: "10px" }}>*/}
                                                {/*    <i className="fa-solid fa-server" /></button>*/}
                                                {/*</p>*/}
                                            </div>
                                            <div className="recoard-bata service-content-area">

                                                <>
                                                    <div className="table-responsive">
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                                <thead className="sticky-top">
                                                                    <tr>
                                                                        <th>History</th>
                                                                        <th>{dashboardRecords.hMap}</th>
                                                                        <th>{dashboardRecords.hqr}</th>
                                                                        <th>{dashboardRecords.hAssignTo}</th>
                                                                        <th>{dashboardRecords.hVenue}</th>
                                                                        <th>{dashboardRecords.hCustodian}</th>
                                                                        <th>{dashboardRecords.hDistrict}</th>
                                                                        <th>{dashboardRecords.hTrunkID}</th>
                                                                        <th>{dashboardRecords.hLatitude}</th>
                                                                        <th>{dashboardRecords.hLongitude}</th>
                                                                        <th>{dashboardRecords.hUser}</th>
                                                                        <th>{dashboardRecords.hCreatedBy}</th>
                                                                        <th>{dashboardRecords.hCreatedDate}</th>
                                                                        <th>{dashboardRecords.hModifiedBy}</th>

                                                                    </tr>
                                                                </thead>
                                                                {isModalOpen && (
                                                                    <div className="modal show" tabIndex="-1" role="dialog">
                                                                        <div className="modal-dialog" role="document">
                                                                            <div className="modal-content   " style={{ backgroundColor: "#fff" }}>
                                                                                <div class="modal-header">
                                                                                    <h5 class="modal-title font-weight-bold" id="exampleModalLabel">History data</h5>
                                                                                    {/*<button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={closeModal} style={{ fontWeight: "bold" }}>*/}
                                                                                    {/*    <span aria-hidden="true">&times;</span>*/}
                                                                                    {/*</button>*/}
                                                                                    <button title="History" data-toggle="modal" data-target="#exampleModalCenter" onClick={closeModal} style={{ marginLeft: "10px" }}>
                                                                                        <i className="fa-solid fa-xmark" /></button>
                                                                                </div>
                                                                                <div class="modal-body">
                                                                                    <section className="recoard-table mt-3">
                                                                                        <div className="row">
                                                                                            <div className="col-lg-12">
                                                                                                <div className="content-box">
                                                                                                    <div className="heading-box d-block d-sm-flex">
                                                                                                        <div className="heading">
                                                                                                            <h6 className="m-0 mb-2 mb-sm-0 font-weight-bold text-primary">
                                                                                                                {trackingTabledata.totalRecord !== undefined && trackingTabledata.totalRecord !== null ?
                                                                                                                    (`Total Records : ${trackingTabledata.totalRecord}`)
                                                                                                                    :
                                                                                                                    (`No record found`)}
                                                                                                            </h6>
                                                                                                        </div>

                                                                                                    </div>
                                                                                                    <div className="recoard-bata service-content-area" style={{ padding: "0px" }}>
                                                                                                        {!loading ?
                                                                                                            (
                                                                                                                <>
                                                                                                                    <div className="table-responsive" style={{
                                                                                                                        oveflow: "auto",
                                                                                                                        maxHeight: "300px"
                                                                                                                    }}>
                                                                                                                        {trackingTabledata?.length !== 0 ?
                                                                                                                            (
                                                                                                                                trackingTabledata?.totalRecord !== null ? (<table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                                                                                                    <thead className="sticky-top">
                                                                                                                                        <tr >


                                                                                                                                            <th>{trackingTabledata.hImage}</th>
                                                                                                                                            <th>{trackingTabledata.hMap}</th>
                                                                                                                                            <th>{trackingTabledata.hPacketStatus}</th>
                                                                                                                                            <th>{trackingTabledata.hTrunkID}</th>
                                                                                                                                            <th>{trackingTabledata.hEvent}</th>
                                                                                                                                            <th>{trackingTabledata.hVenue}</th>
                                                                                                                                            <th>{trackingTabledata.hCustodian}</th>
                                                                                                                                            <th>{trackingTabledata.hDistrict}</th>
                                                                                                                                            <th>{trackingTabledata.hVehicleNo}</th>
                                                                                                                                            <th>{trackingTabledata.hAssignedTo}</th>
                                                                                                                                            <th>{trackingTabledata.hLatitude}</th>
                                                                                                                                            <th>{trackingTabledata.hLongitude}</th>
                                                                                                                                            <th>{trackingTabledata.hCreatedBy}</th>
                                                                                                                                            <th>{trackingTabledata.hCreatedDate}</th>
                                                                                                                                            <th>{trackingTabledata.hModifiedBy}</th>
                                                                                                                                            <th>{trackingTabledata.hModifiedDate}</th>
                                                                                                                                        </tr>
                                                                                                                                    </thead>
                                                                                                                                    <tbody>
                                                                                                                                        {trackingTabledata?.trackingData !== null ?
                                                                                                                                            (
                                                                                                                                                (trackingTabledata?.trackingData)?.map((event, index) => (
                                                                                                                                                    <tr key={index} className={index % 2 === 0 ? "TableTrhover even-row" : "TableTrhover odd-row"}>


                                                                                                                                                        {/*<td ><a type="button" href={event.image} target="_blank"> <i className="fa fa-image" style={{ color: "blue" }}></i></a> </td>*/}
                                                                                                                                                        <td>
                                                                                                                                                            {event.image ? (
                                                                                                                                                                <Link style={{ cursor: 'pointer' }} to={`/Images#data:image/png;base64,${event.image}`} target="_blank">
                                                                                                                                                                    <i className="fa fa-image" style={{ color: "blue" }}></i>
                                                                                                                                                                </Link>
                                                                                                                                                            ) : (
                                                                                                                                                                <div></div>
                                                                                                                                                            )}
                                                                                                                                                        </td>
                                                                                                                                                        <td >
                                                                                                                                                            {event.map ? (


                                                                                                                                                                <a type="button" href={event.map} target="_blank"> <i className="fas fa-map-marker-alt" style={{ color: "blue" }}></i></a>
                                                                                                                                                            ) : (
                                                                                                                                                                <a type="button" href="https://www.google.co.in/maps/@28.6469655,77.0932634,10z?hl=en&entry=ttu" target="_blank"> <i className="fas fa-map-marker-alt" style={{ color: "blue" }}></i></a>
                                                                                                                                                            )}
                                                                                                                                                        </td>
                                                                                                                                                        <td>{event.packetStatus}</td>
                                                                                                                                                        <td>{event.trunkID}</td>
                                                                                                                                                        <td>{event.event}</td>
                                                                                                                                                        <td>{event.venue}</td>

                                                                                                                                                        <td>{event.custodian}</td>
                                                                                                                                                        <td>{event.district}</td>
                                                                                                                                                        <td>{event.vehicleNo}</td>
                                                                                                                                                        <td>{event.assignedTo}</td>
                                                                                                                                                        <td>{event.latitude}</td>
                                                                                                                                                        <td>{event.longitude}</td>
                                                                                                                                                        <td>{event.createdBy}</td>
                                                                                                                                                        <td>{event.createdDate}</td>
                                                                                                                                                        <td>{event.modifiedBy}</td>
                                                                                                                                                        <td>{event.modifiedDate}</td>
                                                                                                                                                    </tr>
                                                                                                                                                ))
                                                                                                                                            ) : (<></>)}
                                                                                                                                    </tbody>
                                                                                                                                </table>) : (<></>)

                                                                                                                            ) : (<></>)}
                                                                                                                    </div>
                                                                                                                    {countNo > 1 ?
                                                                                                                        <Pagination count={countNo} variant="outlined" page={currentPageNo} shape="rounded" />

                                                                                                                        : ''}
                                                                                                                </>
                                                                                                            ) : (
                                                                                                                <div className='d-flex align-items-center justify-center'>

                                                                                                                </div>
                                                                                                            )
                                                                                                        }
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                    </section>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                <tbody>
                                                                    {dashboardRecords?.getDashboardDetailData !== null ?
                                                                        (
                                                                            (dashboardRecords?.getDashboardDetailData)?.map((dashboard, index) => (
                                                                                <tr className="tablerow" onClick={() => handleHighlight(dashboard)} style={{ background: dashboard.trunkID === ColoredRow ? '#cbe2ff' : '' }} key={index} >
                                                                                    <td ><button title="History" data-toggle="modal" data-target="#exampleModalCenter" key={index} onClick={() => {
                                                                                        getTrackingData('', dashboard.tunkID)
                                                                                    }} style={{ marginLeft: "10px" }}>
                                                                                        <i className="fa-solid fa-server" style={{ color: "black" }} /></button></td>

                                                                                    <td >
                                                                                        {dashboard.map ? (


                                                                                            <a type="button" href={dashboard.map} target="_blank"> <i className="fas fa-map-marker-alt" style={{ color: "blue" }}></i></a>
                                                                                        ) : (
                                                                                            <div></div>
                                                                                        )}
                                                                                    </td>

                                                                                    <td>

                                                                                        <Link style={{ cursor: 'pointer' }} to={`/QrCode#data:image/png;base64,${dashboard.qr}`} target="_blank">
                                                                                            <i className="fa fa-qrcode" style={{ fontSize: "19px", }}></i>
                                                                                        </Link>
                                                                                    </td>

                                                                                    <td>{dashboard.assingTo}</td>
                                                                                    <td>{dashboard.venue}</td>
                                                                                    <td>{dashboard.custodian}</td>
                                                                                    <td>{dashboard.district}</td>
                                                                                    <td>{dashboard.tunkID}</td>
                                                                                    <td>{dashboard.latitude}</td>
                                                                                    <td>{dashboard.longitude}</td>
                                                                                    <td>{dashboard.user}</td>
                                                                                    <td>{dashboard.createdBy}</td>
                                                                                    <td>{dashboard.createdDate}</td>
                                                                                    <td>{dashboard.modifiedBy}</td>
                                                                                </tr>
                                                                            ))
                                                                        ) : (<></>)}
                                                                </tbody>
                                                            </table>

                                                        </div>
                                                    </div>
                                                </>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </section>) : <></>
                    }


                    {
                        Record.totalData !== '0' &&
                            showDynamicgrid ? (isVisible &&
                                <section className="recoard-table mt-3">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="recoard-bata service-content-area">
                                                {SubLoading ?
                                                    <div className="table-responsive" id="districtDataTable">
                                                        {DynamicRecords.length === 0 ? <>No Record Found</> :
                                                            <Table
                                                                tableData={DynamicRecords}
                                                                currentPageNo={currentPageNo}
                                                                getTrackingData={getTrackingData}
                                                                trackingTabledata={trackingTabledata}
                                                                handleCheckboxChange={handleCheckboxChange}
                                                                UpdateTrunkStatus={UpdateTrunkStatus}
                                                                loading={loading}
                                                                isModalOpen={isModalOpen}
                                                                closeModal={closeModal}
                                                                handleChange1={handleChange1}
                                                            />
                                                        }
                                                    </div>
                                                    :
                                                    <div className='d-flex align-items-center justify-center'>
                                                        <ColorRing
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="blocks-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="blocks-wrapper"
                                                            colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                                                        />
                                                    </div>}
                                            </div>
                                        </div>
                                    </div>
                                </section>) :
                            <></>
                    }
                </div>
                <ToastContainer theme='colored' />
            </main>


        </>
    )
}
export default Dashboard